import React, { FC } from 'react'
import styles from './CuratedDeals.module.scss'
import { SAArtwork } from 'types/Artwork'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import { LocaleCurrency } from 'components/FormatPrice'
import { ARTWORK_STATUS } from '../helpers'
import ListConnector, { ConnectorProps as ListProps } from '../connectors/List'

type PriceProps = ListProps & {
  artwork: SAArtwork
}

const Price: FC<PriceProps> = ({ artwork, discount, promoCode }) => {
  const { originalStatus, hasOpenEditions, minPrintPrice, listPrice } = artwork
  const isSold = originalStatus === ARTWORK_STATUS.SOLD
  const isUnavailable = originalStatus === ARTWORK_STATUS.UNAVAILABLE
  const isReserved = originalStatus === ARTWORK_STATUS.RESERVED
  const discountedPrice = (1 - discount / 100) * listPrice
  if (isReserved) {
    return (
      <div className={styles.availabilityStatus}>
        <span>RESERVED</span>
      </div>
    )
  }

  if (isSold && !hasOpenEditions) {
    return (
      <div className={styles.availabilityStatus}>
        <span>SOLD</span>
      </div>
    )
  }

  if (isUnavailable && !hasOpenEditions) {
    return (
      <div className={styles.outlinedChip}>
        <span>NOT AVAILABLE</span>
      </div>
    )
  }

  if ((isSold || isUnavailable) && hasOpenEditions) {
    return (
      <h6 className={styles.printsFrom} data-type='prints-price'>
        Prints From <LocaleCurrency price={convertFromCentsToDollars(minPrintPrice)} />
      </h6>
    )
  }
  return (
    <div className={styles.price}>
      <h6 className={styles.discountedPrice}>
        <LocaleCurrency price={convertFromCentsToDollars(discountedPrice)} /> With Code {promoCode}
      </h6>
      <p className={styles.listPrice}>
        {`(`}
        <LocaleCurrency price={convertFromCentsToDollars(listPrice)} /> Orig. Price{`)`}
      </p>
    </div>
  )
}

export default ListConnector(Price)
